/**
 * Find the first tag with tag_type 'role' from a shift's tag_ids array
 * @param {Array} tags - Array of all available tags
 * @param {Object} shift - The shift object containing tag_ids array
 * @returns {Object|null} The first role tag found, or null if none found
 */
const findFirstRoleTag = (tags, shift) => {
  if (!tags || !Array.isArray(tags) || !shift || !shift.filter_tag_ids || !shift.non_filter_tag_ids || !Array.isArray(shift.filter_tag_ids) || !Array.isArray(shift.non_filter_tag_ids) ) {
    return null;
  }

  // Find the first tag that has tag_type 'role' and is in the shift's tag_ids
  return tags.find(tag => 
    tag.tag_type === 'role' && (shift.filter_tag_ids.includes(tag.id) || shift.non_filter_tag_ids.includes(tag.id))
  ) || null;
};

const getRoleTagColor = (tags, shift) => {
  const roleTag = findFirstRoleTag(tags, shift);
  return roleTag ? roleTag.color_code : null;
};


export { findFirstRoleTag, getRoleTagColor};